/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Tools(props) {
  return (
    <svg {...props} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.4875 2.583C13.4904 2.583 14.3037 3.39649 14.3039 4.39941V5.24902H14.672C15.3597 5.24907 15.9883 5.63791 16.2961 6.25292L18.6671 10.9941L18.7462 11.1523V15.6006C18.746 16.6034 17.9328 17.416 16.9298 17.416H3.06949C2.12942 17.4158 1.356 16.7017 1.26285 15.7861L1.25308 15.6006V11.1523L1.33218 10.9941L3.70328 6.25292C4.01084 5.63788 4.63968 5.24928 5.3273 5.24902H5.69546V4.39941C5.69564 3.39663 6.50911 2.58323 7.51187 2.583H12.4875ZM2.75308 15.6006L2.75992 15.6641C2.78949 15.8079 2.91696 15.9158 3.06949 15.916H16.9298C17.1043 15.916 17.246 15.775 17.2462 15.6006V12.0801H14.3039V12.6621C14.3039 13.0763 13.968 13.4121 13.5539 13.4121C13.1398 13.4119 12.8039 13.0762 12.8039 12.6621V12.0801H7.19546V12.6621C7.19546 13.0763 6.85968 13.4121 6.44546 13.4121C6.03154 13.4118 5.69546 13.0761 5.69546 12.6621V12.0801H2.75308V15.6006ZM5.3273 6.74902C5.20784 6.74928 5.09855 6.81695 5.04507 6.92382L3.21695 10.5801H5.69546V9.99706C5.69564 9.5832 6.03164 9.2474 6.44546 9.24706C6.85957 9.24706 7.19529 9.583 7.19546 9.99706V10.5801H12.8039V9.99706C12.804 9.58314 13.14 9.24729 13.5539 9.24706C13.9679 9.2471 14.3037 9.58302 14.3039 9.99706V10.5801H16.7824L14.9543 6.92382C14.9006 6.81698 14.7916 6.74907 14.672 6.74902H5.3273ZM7.51187 4.083C7.33754 4.08323 7.19564 4.22506 7.19546 4.39941V5.24902H12.8039V4.39941C12.8037 4.22491 12.662 4.083 12.4875 4.083H7.51187Z"
        fill="#35424F"
      />
    </svg>
  )
}

Tools.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Tools
